import cryptoJS from 'crypto-js'
import store from "@/store/pms/landlord/index";

export default {
    // 加密函数
    encrypt(word) {
        let key = cryptoJS.MD5('JXWL_OTA_' + (JSON.parse(sessionStorage.getItem('landlordInfo'))?.token || store.getters.getToken)).toString().substring(0, 16);
        key = cryptoJS.enc.Utf8.parse(key);
        let encrypted = cryptoJS.AES.encrypt(word, key, {
            mode: cryptoJS.mode.ECB,
            padding: cryptoJS.pad.Pkcs7
        }).toString()

        return encrypted;
    },

    // 解密函数
    decode(word) {
        let key = cryptoJS.MD5('JXWL_OTA_' + (JSON.parse(sessionStorage.getItem('landlordInfo'))?.token || store.getters.getToken)).toString().substring(0, 16)
        key = cryptoJS.enc.Utf8.parse(key);
        let decrypt = cryptoJS.AES.decrypt(word, key, {
            mode: cryptoJS.mode.ECB,
            padding: cryptoJS.pad.Pkcs7
        }).toString(cryptoJS.enc.Utf8);

        return decrypt
    }
}